import { Feature, Product, Role } from '../enums';

enum NavTypes {
  core = 'core',
  side = 'side',
}

export enum NavItemType {
  // TODO: Once all users have access to social challenges, remove challenges navItemType
  challenges = 'challenges',
  elevatedAccess = 'elevatedAccess',
  invites = 'invites',
  quickActions = 'quickActions',
  standard = 'standard',
}

export interface NavItem {
  type: NavItemType;
  link?: string;
  icon?: string;
  imageType?: string;
  title?: string;
  displayOrder?: { [product in Product]?: { [navType in NavTypes]?: number } };
  external?: boolean;
  feature?: Feature;
  roles?: Role[];
}
